export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  handleContinue() {
    this.store.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.store.goToLogin()
  },
})
